import React from 'react';
import * as moment from "moment";

const DateDisplay = ({ date, format, ...props }) => {
  let str;
  if (!date) {
    str = 'None';
  } else if (typeof(date) === 'object' && date.format) {
    str = date.format(format || 'MM/DD/YYYY');
  } else if (typeof(date) === "string") {
    str = date;
  } else {
    str = moment(date).format('MM/DD/YYYY');
  }
  return (
    <span {...props}>
      {str}
    </span>
  );
};

export default React.memo(DateDisplay);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/DateDisplay.js